/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';
import { Pair } from './pair';

export interface Order {
  id?: number;
  accountId?: number;
  account?: Account;
  pairId?: number;
  pair?: Pair;
  initiatorId?: number;
  initiatorType?: Order.InitiatorTypeEnum;
  orderStrategy?: Order.OrderStrategyEnum;
  directPairs?: Array<Pair>;
  side?: Order.SideEnum;
  ordType?: Order.OrdTypeEnum;
  timeInForce?: Order.TimeInForceEnum;
  quantity?: number;
  clientRegisterPrice?: number;
  clientRegisterTotal?: number;
  receiveTime?: string;
  orderStatus?: Order.OrderStatusEnum;
  rejectReason?: string;
  lpVenues?: string;
  state?: any | null;
  leavesQty?: number;
  filledQty?: number;
  clientExecVolume?: number;
  realExecVolume?: number;
  clOrdId?: string;
  hedgedQty?: number;
  hedgePnl?: number;
  limitPrice?: number;
  stopPrice?: number;
  lastQuoteAssetPrice?: number;
  baseAssetFee?: number;
  baseAssetFeeConverted?: number;
  lpFilledQty?: number;
  doneAt?: string;
  revenue?: number;
  clientExecutedPrice?: number;
  realExecutedPrice?: number;
}
export namespace Order {
  export const InitiatorTypeEnum = {
    Admin: 'ADMIN',
    ApiKey: 'API_KEY',
    User: 'USER',
    Algo: 'ALGO',
    Fix: 'FIX',
  } as const;
  export type InitiatorTypeEnum = (typeof InitiatorTypeEnum)[keyof typeof InitiatorTypeEnum];
  export const OrderStrategyEnum = {
    Register: 'REGISTER',
    Default: 'DEFAULT',
    Direct: 'DIRECT',
  } as const;
  export type OrderStrategyEnum = (typeof OrderStrategyEnum)[keyof typeof OrderStrategyEnum];
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
  export const OrdTypeEnum = {
    Limit: 'LIMIT',
    Market: 'MARKET',
    StopLimit: 'STOP_LIMIT',
  } as const;
  export type OrdTypeEnum = (typeof OrdTypeEnum)[keyof typeof OrdTypeEnum];
  export const TimeInForceEnum = {
    Gtc: 'GTC',
    Ioc: 'IOC',
    Fok: 'FOK',
  } as const;
  export type TimeInForceEnum = (typeof TimeInForceEnum)[keyof typeof TimeInForceEnum];
  export const OrderStatusEnum = {
    Active: 'ACTIVE',
    Canceled: 'CANCELED',
    Filled: 'FILLED',
    PartiallyFilled: 'PARTIALLY_FILLED',
    PartiallyFilledCanceled: 'PARTIALLY_FILLED_CANCELED',
    Rejected: 'REJECTED',
    WaitingTrigger: 'WAITING_TRIGGER',
  } as const;
  export type OrderStatusEnum = (typeof OrderStatusEnum)[keyof typeof OrderStatusEnum];
}
